function promisify(fn) {
  return function(...args) {
    return new Promise(function(resolve, reject) {
      args.push(function(err, ...arg) {
        if (err) {
          reject(err)
        } else {
          resolve(...arg)
        }
      })
      fn.apply(null, args)
    })
  }
}

export default promisify



// WEBPACK FOOTER //
// ./packages/utils/promisify.js